/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './HeaderNav.css';

const HeaderNav = (props) => {
  const {
    menuAction,
    pageNavList,
  } = props;

  const PageNavItem = pageNavList.map(function (item, index) {
    return (
      <NavItem
        eventKey={ index+1 }
        onClick={(event) => {
          event.stopPropagation && event.stopPropagation();
          event.stopImmediatePropagation && event.stopImmediatePropagation();
          event.preventDefault();

          item.action();
          menuAction && menuAction();
          return false;
        }}
        data-key={'app.header'+index}
        key={ item.id }
        href={item.path}
      >
        {
          item.id === 'help' && <i aria-hidden={true} className={'icon icon-circle-help'}>{}</i>
        }

        { item.name }
      </NavItem>
    );
  });

  return (
    <Nav pullRight className="main-nav">
      {PageNavItem}
    </Nav>
  )
};

HeaderNav.propTypes = {
  menuAction: PropTypes.func,
  currentPage: PropTypes.string,
  pageNavList: PropTypes.array,
};

export default HeaderNav;


// WEBPACK FOOTER //
// ./src/shared/NavigationBar/components/HeaderNav.js